import { FC } from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { Trans } from '@libs/i18n';
import { WarningIcon } from '@phosphor-icons/react';

export const WarningBanner: FC = observer(() => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      variant="panel"
      sx={{
        backgroundColor: 'orange.100',
        border: `1px solid ${theme.palette.grey[300]}`,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
        <WarningIcon color={theme.palette.orange[500]} size={20} />
        <Typography variant="textSM_regular" sx={{ color: 'orange.500' }}>
          <Trans i18nKey="assessments.summary.warningMessage" />
        </Typography>
      </Box>
    </Paper>
  );
});
